import { useIntl } from 'react-intl'

export function useHighlightMessages() {
  const intl = useIntl()

  const highlightMessageAvailableForDates = intl.formatMessage({
    id: 'ojRHOgxIYTVDZTonc6-A',
    defaultMessage: 'We found a limited time deal for your hotel. Choose dates and book now before it ends!',
  })

  const highlightMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'lPbRpiYz-nztlbYe5H9J',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to enjoy this special offer',
    },
    { minNumNights },
  )

  const unavailableBannerMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'FRjZTVd0n4-ExM44L6Es',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to unlock this offer',
    },
    { minNumNights },
  )

  const highlightMessageUnavailableForDates = (saleUnit: string) => {
    const unit = saleUnit.toLowerCase()
    switch (unit) {
      case 'room':
        return intl.formatMessage({
          id: 'e9KFX52TiGGxqmDcsZlz',
          defaultMessage: 'There are no rooms available for your selected dates.',
        })
      case 'night':
        return intl.formatMessage({
          id: 'UD4398gbzfd5FOy2lqbY',
          defaultMessage: 'There are no nights available for your selected dates.',
        })
      case 'package':
        return intl.formatMessage({
          id: 'KbG_ezczJUArNpPvY5Ts',
          defaultMessage: 'There are no packages available for your selected dates.',
        })
      default:
        return intl.formatMessage(
          {
            id: 'T6iCX4YTOWG2dd1wPOQ9',
            defaultMessage: 'There are no {unit} available for your selected dates.',
          },
          { unit },
        )
    }
  }

  return {
    highlightMessageAvailableForDates,
    highlightMessageStayMinNights,
    unavailableBannerMessageStayMinNights,
    highlightMessageUnavailableForDates,
  }
}
